import {baseImgHost} from '@/api/api'
import { map } from 'jquery'
import imgurl from "./imgs/navTour.png"
// 中英文互译功能
export const  tarberEnglishMap = {
    0: {
        chinese: '景点',
        english: 'Scenic Spot'    
    },
    1: {
        chinese: '路线',
        english: 'Route'   
    },
    2: {
        chinese: '服务中心',
        english: 'Service Center' 
    }
}

export const sidebarEnglishMap = {
    0: {
        chinese: '简介',
        english: 'Introduction' 
    },
    1: {
        chinese: '帮助',
        english: 'Help'
    },
    2: {
        chinese: '手绘地图',
        english: 'Painting'
    },
    3: {
        chinese: '自动讲解',
        english: 'Auto'
    },
    4: {
        chinese: '反馈',
        english: 'Feedback'
    },
    5: {
        chinese: '英文',
        english: 'Chinese'
    }
}
export const bottomListEnglishMap = {
    0: {
        chinese: '去这里',
        english: 'Go there'
    },
    1: {
        chinese: '请输入景点',
        english: 'Please enter the scenic spot'
    },
    2: {
        chinese: '未找到含',
        english: 'Contains not found'
    },
    3: {
        chinese: '的景点或目的地',
        english: 'of scenic spot or destination'
    }
}

export const dialogEngLishMap = {
    0: {
        chinese: '点击去这里',
        english: 'Go there'
    }
}
export const introduceDialogEngLishMap = {
    0: {
        chinese: '开放时间: ',   
        english: 'Opening Hours'
    },
    1: {
        chinese: '景区地址: ',
        english: 'Address'
    },
    2: {
        chinese: '小泥人提供技术支持! 详情咨询: ',
        english: 'Xiao Niren company provides technical support .For more details, please consult'
    },  
    3: {
        chinese: '了解更多: ',
        english: 'Learn more'
    },
}

export const feedbackDialogEnglishMap = {
    0: {
        chinese: '联系我们',
        english: 'Contact Us'
    },
    1: {
        chinese: '使用中遇到问题, 请联系客服',
        english: 'Please contact us if you have any problem in use'  
    },
    2: {
        chinese: '地图问题',
        english: 'Map problem'   
    },
    3: {
        chinese: '语音问题',
        english: 'Voice problem' 
    },
    4: {
        chinese: '功能问题',
        english: 'Function problem'
    },
    5: {
        chinese: '其他',
        english: 'Other problems'
    },
    6: {
        chinese: '客服',
        english: 'Customer Service'
    },
    7: {
        chinese: '手机号',
        english: 'phone number'
    },
    8: {
        chinese: '请输入您的手机号',
        english: 'Please enter your mobile phone number'
    },
    9: {
        chinese: '描述',
        english: 'description'
    },
    10: {
        chinese: '请留下您的宝贵意见^_^',
        english: 'Please leave your valuable comments^_^'
    },
    11: {
        chinese: '提交',
        english: 'Submit'
    }
}

export const payDialogEnglishMap = {
    0: {
        chinese: '元',
        english: 'RMB'
    },
    1: {
        chinese: '购买后可永久收听全部讲解',
        english: 'After purchase, you can listen to all the explanations permanently'
    },
    2 : {
        chinese: '取消',
        english: 'Cancel'
    },
    3: {
        chinese: '确认',
        english: 'Confirm'
    }
}

export const infoPlayEnglishMap = {
    0: {
        chinese: '解说',
        english: 'Commentary'
    },
    1: {
        chinese: '详情',
        english: 'Details'
    },
    // 2:{
    //     chinese: '挑战',
    //     english: 'Details'
    // }
}

export const messageEnglishMap = {
    0: {
        chinese: '如需播放该音频,请先关闭右上角自动播放按钮',
        english: 'If the audio needs to be played  , Please turn off the auto play button in the upper right corner first' 
    }, 
    1: {
        chinese: '您当前不在景区范围内',
        english: 'You are not in the scenic area at present' 
    },
    2: {
        chinese: '提交成功, 感谢您提出的宝贵意见^_^',
        english: 'Submitted successfully! Thank you for your valuable comments ^_^' 
    },
    3: {
        chinese: '已关闭自动播放',
        english: 'Autoplay has been turned off' 
    },
    4: {
        chinese: '自动播放模式已开启',
        english: 'Autoplay mode is on' 
    },
}

export const  typeEnglishMap = {
    '地图': {
        chinese: '地图问题',
        english: 'Map problem'
    },
    '语音': {
            chinese: '语音问题',
            english: 'Voice problem'
    },
    '功能': {
        chinese: '功能问题',
        english: 'Function problem'
    },
    '其他': {
        chinese: '其他',
        english: 'Other problems'
    }
  }
  
  export const distanceEnglishMap = {
      '千米': {
        chinese: '千米',
        english: 'km'
      },
      '米': {
        chinese: '米',
        english: 'm'
      }
  }
  // 点击marker时的弹窗带有跳转二级链接的
  export const templateContent = `<div style='width: 287px; display: flex; z-index: 10000000;position: relative;font-size: 12px !important'>
  
              <img src='https://mapapi.qq.com/web/lbs/javascriptGL/demo/img/em.jpg' id='infoImg' style='display: block; width: 94px; height: 94px; margin-right: 12px; margin-top: 10px; border-radius: 6px'>
              <div style='width: 165px; margin-top: 10px'>
            
               <p id='detail' style='width: 165px; height: 50px;white-space:normal; font-size: 12px ;
             　'>
             
             </p>
             <p id='info' style='width:100%;text-align:left;padding-left:5px;color:#8A2BE2'>详情</p>
   <p class='button-list' style='width: 165px;height: 33px;display: flex;justify-content: space-between;margin-top: 10px;align-items:center;'>
                 <span style='width: 75px; height: 33px; font-size: 12px;background-color: rgb(255,221,2); display: inline-block;color: rgb(114,64,11); line-height: 33px; border-radius: 6.4px' id='audioInfo'>
                 <img src='${baseImgHost}/ditu/erji2.png' style='width: 15px; height: 15px; margin-right: 4px;vertical-align: middle;' id='audioImg'>
                 <span id='commentary'>解说</span></span>
                 <span id="tourDaolan" style='width: 75px; height: 33px;font-size: 12px; background-color: rgb(255, 221, 2); display: inline-block; line-height: 33px; border-radius: 6.4px; color: rgb(114,64,11)' >
                 <img    style='width: 15px; height: 15px;margin-right: 4px; vertical-align: middle;' src='https://f.xiaoniren.cn/ditu/daohang.png' />
                 <span >导航</span>
                 </span>
                
                 <span id='tour' style='width: 50px; height: 33px; font-size: 12px;background-color: rgb(255,221,2); display: flex;color: rgb(114,64,11); border-radius: 6.4px;align-items:center;justify-content:center;'>
                    <img src='${imgurl}' style='width:20px;height:auto;'></img>
                 </span>
               
                 </p>
              </div>
              <p id='windowInfoTitle' style='font-size: 14px;color: #4d4d4d; position: absolute;top: -18px;left: 0;'>标题</p>
              
              
     </div>`;
     // 点击marker时的弹窗无跳转二级链接的
     export const templateContent2 = `<div style='width: 287px; display: flex; z-index: 10000000;position: relative;font-size: 12px !important'>
    
              <img src='https://mapapi.qq.com/web/lbs/javascriptGL/demo/img/em.jpg' id='infoImg' style='display: block; width: 94px; height: 94px; margin-right: 12px; margin-top: 10px; border-radius: 6px'>
              <div style='width: 165px; margin-top: 10px'>
              
               <p id='detail' style='width: 165px;height:40px;white-space:normal; font-size: 12px ;overflow: hidden; 
             text-overflow:ellipsis;'>
             </p>
             <p id='info' style='width:100%;text-align:left;padding-left:5px;color:#8A2BE2'>详情</p>
   <p class='button-list' style='width: 165px;height: 33px;display: flex;justify-content: space-between;margin-top: 10px;align-items:center;'>
                 <span style='width: 75px; height: 33px; font-size: 12px;background-color: rgb(255,221,2); display: inline-block;color: rgb(114,64,11); line-height: 33px; border-radius: 6.4px' id='audioInfo'>
                 <img src='${baseImgHost}/ditu/erji2.png' style='width: 15px; height: 15px; margin-right: 4px;vertical-align: middle;' id='audioImg'>
                 <span id='commentary'>解说</span></span>

                 <span id="tourDaolan" style='width: 75px; height: 33px;font-size: 12px; background-color: rgb(255, 221, 2); display: inline-block; line-height: 33px; border-radius: 6.4px; color: rgb(114,64,11)' >
                 <img    style='width: 15px; height: 15px;margin-right: 4px; vertical-align: middle;' src='https://f.xiaoniren.cn/ditu/daohang.png' />
                 <span >导航</span>
                 </span>
                
                
               
                 </p>
              </div>
             

              <p id='windowInfoTitle' style='font-size: 14px;color: #4d4d4d; position: absolute;top: -18px;left: 0;'>标题</p>
     </div>`;

    export function myInfoWindow(options) {
        this.position = options.position;
        this.content = options.content;
        this.id = options.id;
        this.index = options.index;
        this.type = options.type;
        this.dom;
        var mydom;
        TMap.DOMOverlay.call(this, options);
        // map.setMap(null)
      }

    export function lineTourInfo(options) {
        this.position = options.position;
        this.content = options.content;
        this.id = options.id;
        this.index = options.index;
        this.type = options.type;
        this.dom;
        var mydom;
        TMap.DOMOverlay.call(this, options);
        // map.setMap(null)
      }
      
    export  function addressMasker(options) {
        this.position = options.position;
        this.content = options.content;
        this.id = options.id;
        var mydom;
        TMap.DOMOverlay.call(this, options);

      }
      
      // 以下代码为基于DOMOverlay实现聚合点气泡
    export  function ClusterBubble(options) {
        TMap.DOMOverlay.call(this, options);
      }
    export const typeMap = {
        '地图': 0,
        '语音': 1,
        '功能': 2,
        '其他': 3
      }

  


// WEBPACK FOOTER //
// ./src/static/const.js